var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49805 5.99606C1.49805 6.88549 1.76179 7.75495 2.25593 8.49448C2.75008 9.23401 3.45242 9.81041 4.27414 10.1508C5.09587 10.4912 6.00007 10.5802 6.87241 10.4067C7.74475 10.2332 8.54605 9.80487 9.17497 9.17595C9.80389 8.54702 10.2322 7.74573 10.4057 6.87339C10.5792 6.00105 10.4902 5.09685 10.1498 4.27512C9.80944 3.45339 9.23304 2.75105 8.4935 2.25691C7.75397 1.76277 6.88451 1.49902 5.99508 1.49902C4.73789 1.50375 3.53119 1.99431 2.6273 2.86812L1.49805 3.99738",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49805 1.49902V3.99738H3.9964",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.6082808ae0baa07f15ea22e618ed6f60.svg";
export { ForwardRef as ReactComponent };